@if (data$ | async; as data) {
  <app-alerts />

  <app-admin-cart-settings-form
    [data]="data"
    (submitClickEvent)="handleSubmitClick($event)" />
} @else {
  <app-spinner-filled />
}
